import React from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import AdminLayout from "../layouts/AdminLayout";

// Auth Pages
import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage"; // Now public

// Dashboard Pages
import DashboardPage from "../pages/dashboard/DashboardPage";
import QuoteListPage from "../pages/quotes/QuoteListPage";
import UserListPage from "../pages/users/UserListPage";
import NotificationPage from "../pages/notifications/NotificationPage";
import MessagePage from "../pages/messages/MessagePage";
import SettingsPage from "../pages/settings/SettingsPage";
import ProjectPage from "../pages/projects/ProjectPage";
import NotFoundPage from "../pages/NotFoundPage";
import UnauthorizedPage from "../pages/UnauthorizedPage";

// Components
import ProtectedRoute from "../components/auth/ProtectedRoute";
import ProfilePage from "../pages/ProfilePage";

// Role Definitions (example)
const ROLES = {
  ADMIN: "administrator",
  MANAGER: "manager",
  VIEWER: "viewer", // Example other role
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      {/* --- MODIFICATION START: Signup route is now public --- */}
      <Route path="/signup" element={<SignupPage />} />
      {/* --- MODIFICATION END --- */}

      {/* Protected Admin Routes */}
      <Route
        path="/"
        element={
          // Protect the main layout and all routes nested within it
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {/* Nested routes inherit protection from AdminLayout's ProtectedRoute */}
        <Route index element={<DashboardPage />} /> {/* Default page for '/' */}
        <Route path="quotes" element={<QuoteListPage />} />
        {/* User list remains accessible only by Admins */}
        <Route
          path="users"
          element={
            // Additional protection specific to this nested route
            <ProtectedRoute allowedRoles={[ROLES.ADMIN]}>
              <UserListPage />
            </ProtectedRoute>
          }
        />
        <Route path="profile" element={<ProfilePage />} />
        {/* Messages remain accessible by Admin and Manager */}
        <Route
          path="messages"
          element={
            // Additional protection specific to this nested route
            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.MANAGER]}>
              <MessagePage />
            </ProtectedRoute>
          }
        />
        {/* Notifications, Projects, Settings inherit base protection (logged in user) */}
        <Route path="notifications" element={<NotificationPage />} />
        <Route path="projects" element={<ProjectPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* Unauthorized Page - Still needed for cases where logged-in users try to access roles they don't have */}
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Catch-all 404 Not Found - Should be the last route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
